export const resolveCodeTaxId = ({ agreement = null, specialty = null, explicitCodeTaxId = null } = {}) => {
  if (explicitCodeTaxId !== null && explicitCodeTaxId !== undefined && explicitCodeTaxId !== '') {
    return explicitCodeTaxId
  }

  if (specialty) {
    if (specialty.code_tax_id) return specialty.code_tax_id
    if (specialty.code_tax && specialty.code_tax.id) return specialty.code_tax.id
  }

  if (agreement && agreement.code_tax_id) return agreement.code_tax_id

  return null
}
